import {
  Box,
  Button,
  Checkbox,
  Container,
  FormControlLabel,
  Paper,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import {
  useCompanySteps,
  useHandlePageTraversal,
} from "../../../../common/hooks";
// import { HookedField } from "../../../components/HookedField";
import { HookedForm } from "../../../components/HookedForm";
import { HookedNumberField } from "../../../components/HookedNumberField";
import { HookedField } from "../../../../common/components/HookedField";
import { CompaniesStep, RoutePaths } from "../../../consts/enums";
import { EventName, trackEvent } from "../../../../common/utils/helpers";

export const SellerAskingPrice = () => {
  const { id: startupId } = useParams();
  if (startupId === undefined) {
    return <Navigate to="/dashboard" replace={true} />;
  }
  const { data, isLoading, isError } = useCompanySteps(
    CompaniesStep.STARTUP,
    startupId
  );
  const formHook = useForm();
  const { handleNext } = useHandlePageTraversal(formHook, Number(startupId));
  const navigate = useNavigate();

  useEffect(() => {
    if (data && !isLoading) {
      formHook.reset({ ...data });
    }
  }, [data, isLoading]);
  if (isError) {
    return <Navigate to="/dashboard" replace={true} />;
  }
  return (
    <Box
      sx={{
        backgroundColor: "common.black",
        backgroundImage: "url(/images/BiggerGradient.png)",
        backgroundSize: "cover",
        backgroundPosition: "right",
        backgroundRepeat: "no-repeat",
        width: "100%",
        minHeight: "100%",
      }}
    >
      <Container maxWidth="md" sx={{ padding: 4 }}>
        <Typography variant="h3" sx={{ color: "white" }}>
          PUBLIC INFORMATION
        </Typography>
        <Typography variant="subtitle1" sx={{ color: "common.grayOpacity" }}>
          Other Foundy users can view these details
        </Typography>
        <Paper
          variant="outlined"
          elevation={2}
          sx={{ marginTop: 4, padding: 3, zIndex: 1, position: "relative" }}
        >
          <HookedForm formHook={formHook}>
            <Typography variant="h3" sx={{ marginBottom: 2 }}>
              What is your asking price?
            </Typography>
            <HookedNumberField
              sx={{ marginBottom: 2 }}
              hiddenLabel
              fullWidth
              variant="filled"
              name="asking_price"
              currency
            />

            <FormControlLabel
              name="open_to_offer"
              sx={{
                "&.MuiFormControlLabel-root": {
                  backgroundColor: "common.lightgray",
                  padding: 2,
                  marginLeft: 0,
                  borderRadius: 2,
                  width: "100%",
                  "& span": {
                    fontSize: 12,
                    fontWeight: 500,

                    "&.MuiCheckbox-root": {
                      color: "black",
                    },
                    "&.MuiTypography-root": {
                      color: "common.gray",
                    },
                  },
                },
              }}
              control={
                <Controller
                  name="open_to_offer"
                  control={formHook.control}
                  defaultValue={false}
                  render={({ field: { onChange } }) => (
                    <Checkbox
                      name="open_to_offer"
                      checked={formHook.watch("open_to_offer") || false}
                      onChange={(e) => onChange(e.target.checked)}
                    />
                  )}
                />
              }
              label={
                <>
                  <Typography variant="body1" color="common.black">
                    Open to Offers
                  </Typography>
                  <Typography variant="body2" fontSize={12}>
                    By ticking “Open to offers”, you are choosing to hide your
                    company&apos;s valuation.
                  </Typography>
                </>
              }
            />

            {/* <Box
              component="hr"
              sx={{
                width: "100%",
                borderColor: "common.lightgray",
                borderStyle: "solid",
                marginY: 2,
              }}
            />
            <Typography variant="h3" sx={{ marginBottom: 1 }}>
              Not sure on your asking price?
            </Typography>
            <Typography
              variant="body2"
              sx={{ color: "common.gray", marginBottom: 2 }}
            >
              Our M&A team can help
            </Typography>
            <Button
              onClick={() =>
                window.open("https://foundy.com/advisory/sellers", "_blank")
              }
              sx={{ marginTop: 2 }}
              variant="roundoutlinedgradientblue"
            >
              Get a Valuation
            </Button> */}

            <Box
              component="hr"
              sx={{
                width: "100%",
                borderColor: "common.lightgray",
                borderStyle: "solid",
                marginY: 2,
              }}
            />
            <Typography variant="h3" sx={{ marginBottom: 1 }}>
              What is the minimum price you would accept or reject acquisition
              offers for your business? (Optional)
            </Typography>
            <Stack
              direction="row"
              spacing={3}
              alignItems="center"
              marginBottom={2}
            >
              <Typography
                variant="body2"
                fontWeight={600}
                sx={{ width: "100%" }}
              >
                Price you would probably reject:
              </Typography>
              <HookedNumberField
                hiddenLabel
                currency
                variant="outlined"
                name="asking_price_reject"
              />
            </Stack>
            <Stack direction="row" spacing={3} alignItems="center">
              <Typography
                variant="body2"
                fontWeight={600}
                sx={{ width: "100%" }}
              >
                Price you would probably accept:
              </Typography>
              <HookedNumberField
                hiddenLabel
                currency
                variant="outlined"
                name="asking_price_accept"
              />
            </Stack>

            <Box
              component="hr"
              sx={{
                width: "100%",
                borderColor: "common.lightgray",
                borderStyle: "solid",
                marginY: 2,
              }}
            />
            <Typography variant="h3" sx={{ marginBottom: 2, marginTop: 2 }}>
              Briefly, what is the reasoning behind your asking price?
              (Optional)
            </Typography>
            <HookedField
              fullWidth
              component={TextField}
              variant="outlined"
              name="reason_for_ask_price"
              placeholder='For example, "Based on the average revenue multiples of exits in our market and our growth rate, we believe 4x revenue is fair value."'
              multiline={true}
              minRows="10"
            />

            <Box
              component="hr"
              sx={{
                width: "100%",
                borderColor: "common.lightgray",
                borderStyle: "solid",
                marginY: 2,
              }}
            />
            <Typography variant="h3" sx={{ marginBottom: 2, marginTop: 2 }}>
              What is the reason you are seeking to sell your business?
            </Typography>
            <HookedField
              fullWidth
              component={TextField}
              variant="outlined"
              name="reason"
              placeholder='For example, "I have loved building my business but now I would like to move to another project."'
              multiline={true}
              minRows="10"
            />
          </HookedForm>
        </Paper>
        <Box
          sx={{
            textAlign: "right",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Button
            onClick={() =>
              navigate(RoutePaths.REGISTER_SELLER + `/${startupId}/keyassets`)
            }
            sx={{ marginTop: 2 }}
            variant="roundsecondary"
          >
            Back
          </Button>
          <Button
            onClick={() =>
              handleNext(RoutePaths.REGISTER_SELLER + `/${startupId}/data-room`)
            }
            sx={{ marginTop: 2 }}
            variant="roundgradient"
          >
            Save &amp; Continue
          </Button>
        </Box>
        <Box
          sx={{
            display: { xs: "flex", md: "block" },
            flexDirection: "column",
            marginTop: 8,
          }}
        >
          <Typography
            variant="body2"
            fontWeight={700}
            color="white"
            sx={{ marginBottom: 1 }}
          >
            Just want to enter the marketplace?
          </Typography>
          <Typography
            variant="body2"
            color="common.gray"
            sx={{ marginBottom: 2 }}
          >
            Come back later to complete your Seller Profile.
          </Typography>
          <Button
            variant="roundprimary"
            onClick={() => {
              trackEvent(EventName.SKIP_SIGN_UP);
              navigate(RoutePaths.YOU_ACQUISITION);
            }}
          >
            <span>Skip</span>
          </Button>
        </Box>
      </Container>
    </Box>
  );
};
